export const NAV_ITEMS = [
    {
        key: 'futures',
        label: 'Futures',
        items: [
            { label: 'Advance/Decline', path: '/pages/advance-decline' },
            { label: 'Market Movers', path: '/pages/market-movers' },
            { label: 'Index Top 10', path: '/pages/top-constituents' },
            { label: 'Futures/Spot Chart', path: '/pages/fut-spot-chart' },
            { label: 'Futures Dashboard', path: '/pages/futures-dashboard' },
            { label: 'Trade Finder', path: '/pages/trade-finder' },
        ],
    },
    {
        key: 'options',
        label: 'Options',
        items: [
            { label: 'Option Chain', path: '/pages/option-chain' },
            { label: 'Option Chain Charts', path: '/pages/option-chain-charts' },
            { label: 'Option Action', path: '/pages/option-action' },
            { label: 'Option OI', path: '/pages/option-OI' },
            { label: 'Open Interest Analysis', path: '/pages/open-interest-analysis' },
            { label: 'Market Maker Analysis', path: '/pages/market-maker-analysis' },
            { label: 'Volatility Analysis', path: '/pages/volatality-analysis' },
            { label: 'PCR & OI Trend', path: '/pages/pcr-oi-trend' },
            { label: 'Options Dashboard(Table)', path: '/pages/options-analysis/table' },
            { label: 'Options Dashboard(Charts)', path: '/pages/options-analysis/charts' },
            { label: 'Dynamic Options Analysis', path: '/pages/dynamic-options-analysis' },
            { label: 'Options Premium', path: '/pages/options-premium' },
        ],
    },
    {
        key: 'strategy',
        label: 'Strategy',
        items: [
            { label: 'Dynamic ATM Straddle', path: '/pages/dynamic-atm-straddle' },
            { label: 'Straddle Table', path: '/pages/straddle-table' },
            { label: 'Straddle Charts', path: '/pages/straddle-charts' },
            { label: 'Strangle Table', path: '/pages/strangle-table' },
            { label: 'Strangle Charts', path: '/pages/strangle-charts' },
            { label: 'Multi-Strike Price', path: '/pages/multi-strikes/lp' },
            { label: 'Multi-Strike OI', path: '/pages/multi-strikes/oi' },
            { label: 'Multi-Strike PCR', path: '/pages/multi-strikes/pcr' },
            { label: 'Multi-Strike IV', path: '/pages/multi-strikes/iv' },
            { label: 'Straddle Advance Chart', path: '/pages/straddle-advance-chart' },
            { label: 'Strangle Advance Chart', path: '/pages/strangle-advance-chart' },
            { label: 'Custom Strangle Charts', path: '/pages/custom-strangle' },
            { label: 'Multi Straddle Charts', path: '/pages/multi-straddle' },
            { label: 'ATM Straddle Prices', path: '/pages/atm-straddle-prices' },
        ],
    },
    {
        key: 'charts',
        label: 'Chart',
        items: [
            { label: 'Quick Charts', path: '/pages/quick-charts' },
            { label: 'Advance Chart', path: '/pages/technical-analysis' },
        ],
    },
    {
        key: 'sector',
        label: 'Sector & Market Breadth',
        items: [
            { label: 'NSE Sector & Constituents', path: '/pages/nse-sector-constituents' },
            { label: 'New Highs / New Lows', path: '/pages/highs-lows' },
            { label: 'Highs/Lows Heatmap', path: '/pages/highs-lows-heatmap' },
        ],
    },
    {
        key: 'statistics',
        label: 'FII/DII Statistics',
        items: [
            { label: 'Cash Market Activity', path: '/pages/cash-market-activity' },
            { label: 'FII Index Activity', path: '/pages/fii-index-activity' },
            { label: 'Participant Open Interest', path: '/pages/participant-oi' },
        ],
    },
    {
        key: 'more',
        label: 'More',
        items: [
            { label: 'Pre-Market', path: '/pages/pre-market' },
            { label: 'Seasonality', path: '/pages/seasonality' },
            { label: 'MWPL & Ban List', path: '/pages/ban-list' },
            { label: 'Holiday List', path: '/pages/holiday-list' }, ,
        ],
    },
];